<template>
  <div class="detail_header_fixed">
    <div class="header_container">
      <a class="logo" href="/" />
      <div class="content">
        <h2 class="left_title">
          <em v-if="matDetail.pay_type === 0" class="left_title_free" />
          <em v-else class="left_title_vip" />
          {{ matDetail.name }}
        </h2>
      </div>
      <div class="down_btn" @click="clickDownloadBtn"><em class="icon_down white" />{{ `${matDetail.pay_type === 0 ? '免费下载' : '立即下载'}` }}</div>
      <UserMember class="user_box" />
    </div>
  </div>
</template>

<script>
import UserMember from '@/components/UserMember/index.vue'
import { reportAction } from '@/report/index.js'

export default {
  name: 'HeaderTop',

  components: { UserMember },

  props: {
    matDetail: {
      type: Object,
      default () {
        return {}
      }
    },
    download: {
      type: Function,
      default: () => {}
    }
  },

  methods: {
    clickDownloadBtn () {
      reportAction({ actiontype: 2, pagetype: 4, area: 6 })
      this.download()
    }
  }
}
</script>

<style lang="scss" scoped>
.detail_header_fixed { position: fixed; top: 0; left: 0; z-index: 11; width: 100%; background-color: #fff; box-shadow: 0px 0px 6px 0px rgba(146, 146, 146, 0.1); }
.header_container { display: table; width: $default_content_width; height: 80px; margin: auto; }
.logo { display: table-cell; width: 240px; height: 100%; background-image: url(~@/assets/images/logo_blue.png); background-repeat: no-repeat; background-position: left center; background-size: 180px 33px; }
.content {
  display: table-cell;
  vertical-align: middle;
  .left_title {
    font-size: 24px; line-height: 80px; text-align: center;
    em { display: inline-block; width: 28px; height: 28px; vertical-align: sub; background-size: cover; }
    .left_title_free { margin-right: 8px; background-image: url(~@/assets/images/icon_detail_free.png); }
    .left_title_vip { width: 48px; margin-right: 16px; background-image: url(~@/assets/images/icon_detail_vip.png); }
  }
}
.down_btn { display: inline-block; width: 180px; height: 46px; margin: 16px 0 0 10px; font-size: 22px; line-height: 46px; color: #fff; text-align: center; cursor: pointer; background-color: #3484ff; border: none; border-radius: 8px; outline: none;
  .icon_down { display: inline-block; width: 20px; height: 20px; margin-right: 20px; vertical-align: middle; background-image: url(~@/assets/images/icon_detail_download.png); background-size: cover;
    &.white { background-image: url(~@/assets/images/icon_detail_download_white.png); }
  }
  &:hover { background-color: #2071ed; }
}
@media (max-width: 1800px) {
  .detail_header_fixed {
    .header_container { width: 100%; max-width: $small_content_width; }
  }
}
@media (max-width: 1180px) {
  .detail_header_fixed {
    .logo { display: none; }
    .content .left_title { left: 10px; margin-left: 0; }
  }
}
</style>
